import type { CustomerPrivacy } from "../globals";
import type { TrackingValues } from "../types";

// Older Hydrogen buses do not provide a getter in the subscription context.
export function getTrackingValues(): TrackingValues {
  const privacy: CustomerPrivacy | undefined =
    typeof window === "undefined" ? undefined : window.Shopify?.customerPrivacy;
  const internal = privacy?.__internal;
  const options = { generateFallback: true, tag: "storefront-analytics" };

  return {
    uniqueToken: internal?.uniqueToken?.(options) ?? "",
    visitToken: internal?.visitToken?.(options) ?? "",
  };
}
